import { useState, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import styles from './ProfileBanner.module.css';
import UploadButton from '../UploadButton';
import server from '../../apis/server';

const ProfileBanner = ({ username, url }) => {
  const { isLoggedIn } = useContext(UserContext);
  const [imgHash, setImgHash] = useState(Date.now());

  const uploadFile = async (e) => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('upload', file);

    try {
      await server.post('/images/banner', formData);

      setImgHash(Date.now());
    } catch (err) {}
  };

  return (
    <div className={styles.banner}>
      <img src={`${url}?${imgHash}`} alt="" className={styles.image} />
      {isLoggedIn && isLoggedIn.username === username && (
        <UploadButton id="upload-banner" onUpload={uploadFile}>
          <div className={styles.editIcon}>
            <CreateRoundedIcon style={{ cursor: 'pointer' }} />
          </div>
        </UploadButton>
      )}
    </div>
  );
};

export default ProfileBanner;
